import {DeleteFileInGCSType} from "../service";

export interface UploadedFile {
    fileName: String
    type: String
}

export class UploadedFileDetails {
    appName: string;
    fileName: string;
    type: string;
    id: string;

    constructor(appName: string, fileName: string, type: string, id: string) {
        this.appName = appName;
        this.fileName = fileName;
        this.type = type;
        this.id = id;
    }

    deleteFilePayload(): DeleteFileInGCSType {
        return {
            fileCategoryName: this.type,
            fileName: this.fileName,
            fileNameSpace: this.appName,
        };
    }

    submitFilePayload(): UploadedFile {
        return {type: this.type, fileName: this.fileName}
    }
}